module.exports = __webpack_public_path__ + "img/trgl-17.3ae6c8b8.svg";